<template>
  <HeaderComponent />
  <CguComponent />
  <FooterComponent />
</template>
<script>
import CguComponent from "@/components/CguComponent.vue";
import HeaderComponent from "@/components/HeaderComponent";
import FooterComponent from "@/components/FooterComponent";

export default {
  name: "CguView",
  components: { CguComponent, HeaderComponent, FooterComponent },
};
</script>
<style lang="scss" scoped>
.small {
  font-size: smaller;
}
</style>
